import { Recapt } from '../engine';
import { SessionIdentity } from '../types';
import { BaseEvent, BaseModule } from './base';
import { Namespace } from './types';

interface IdentityUpdaterEvent extends BaseEvent {
  from: SessionIdentity;
  to: SessionIdentity;
}

export class IdentityUpdaterModule extends BaseModule<IdentityUpdaterEvent> {
  public namespace: Namespace = 'identityUpdater';
  private currentIdentity: SessionIdentity | null = null;

  getIdentity() {
    return Recapt.session.getIdentity();
  }

  public onIdentityChange() {
    const identity = this.getIdentity();

    if (this.currentIdentity == null) {
      this.currentIdentity = identity;
      return;
    }

    this.state.push({
      from: this.currentIdentity,
      to: identity,
      timestamp: Recapt.getCurrentSessionTimestamp(),
      where: Recapt.where(),
    });
  }

  onStart() {
    const stored = this.loadStore<{
      state: IdentityUpdaterEvent[];
      currentIdentity: SessionIdentity;
    }>();

    if (stored) {
      if ('state' in stored && stored.state.length > 0) {
        this.state = stored.state;
      }

      if ('currentIdentity' in stored) {
        this.currentIdentity = stored.currentIdentity;
      }
    }

    this.store(() => ({
      state: this.state,
      currentIdentity: this.currentIdentity,
    }));
  }

  purgeState(): void {
    this.state = [];
  }

  buildRequest(
    state: IdentityUpdaterEvent[],
  ): Record<string, unknown> & { state: IdentityUpdaterEvent[] } {
    return {
      state,
    };
  }
}
